const awsConfig = {
  region: process.env.VUE_APP_AWS_REGION,
  userPoolWebClientId: process.env.VUE_APP_USER_POOL_CLIENT_ID,
  identityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID,
  authenticationFlowType: process.env.VUE_APP_AUTH_FLOW_TYPE,
};

export default awsConfig;
